import { useCallback, useReducer } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { PropertyDefinitionsCache } from '../propertyDefinitions/PropertyDefinitionsCache';
import { useIsMounted } from './useIsMounted';
const initialState = {
  status: 'UNINITIALIZED',
  loading: false,
  error: false,
  data: {}
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'PENDING':
      {
        return {
          status: 'PENDING',
          loading: true,
          error: false,
          data: {}
        };
      }

    case 'SUCCESS':
      {
        return {
          status: 'SUCCESS',
          loading: false,
          error: false,
          data: action.payload
        };
      }

    case 'FAILED':
      {
        return {
          status: 'FAILED',
          loading: false,
          error: true,
          data: {}
        };
      }

    default:
      {
        const exhaustiveCheck = action;
        throw new Error(`Unhandled action: ${exhaustiveCheck}`);
      }
  }
};

const cache = new PropertyDefinitionsCache();

const useGetAllPropertyDefinitionsForObjectType = () => {
  const httpClient = useHttpClient();
  const isMounted = useIsMounted();
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    status,
    loading,
    error,
    data
  } = state;
  return useCallback(({
    objectTypeId,
    skip
  }) => {
    if (loading || error || skip) {
      return {};
    }

    if (status === 'SUCCESS') {
      return data;
    }

    dispatch({
      type: 'PENDING'
    });
    cache.get({
      objectTypeId,
      httpClient
    }).then(propertyDefinitions => {
      if (!isMounted.current) {
        return;
      }

      dispatch({
        type: 'SUCCESS',
        payload: propertyDefinitions
      });
    }).catch(err => {
      if (!isMounted.current) {
        return;
      }

      dispatch({
        type: 'FAILED',
        payload: err
      });
    });
    return {};
  }, [loading, error, status, httpClient, data, isMounted]);
}; // exported for unit test usage only


export const _resetCache = () => {
  cache.clear();
};
export { useGetAllPropertyDefinitionsForObjectType };